// extracted by mini-css-extract-plugin
export default {"oilProductsBlock":"OilProducts_oilProductsBlock__GwbmV","container":"OilProducts_container__w9omx","oilProducts":"OilProducts_oilProducts__dTg5T"};